// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanTerminationPropertiesPatchDto
 */
export interface IPlanTerminationPropertiesPatchDto {
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesPatchDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesPatchDto
     */
    coverage_end_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesPatchDto
     */
    claim_last_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPlanTerminationPropertiesPatchDto
     */
    hsa_transfer_of_assets?: IPlanTerminationPropertiesPatchDtoHsaTransferOfAssetsEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPlanTerminationPropertiesPatchDtoHsaTransferOfAssetsEnum {
    BULK_TRANSFER = 'BULK_TRANSFER',
    EMPLOYEE_OWNED = 'EMPLOYEE_OWNED',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}


/**
 * Check if a given object implements the IPlanTerminationPropertiesPatchDto interface.
 */
export function instanceOfIPlanTerminationPropertiesPatchDto(value: object): value is IPlanTerminationPropertiesPatchDto {
    return true;
}

export function IPlanTerminationPropertiesPatchDtoFromJSON(json: any): IPlanTerminationPropertiesPatchDto {
    return IPlanTerminationPropertiesPatchDtoFromJSONTyped(json, false);
}

export function IPlanTerminationPropertiesPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanTerminationPropertiesPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'coverage_end_date': json['coverage_end_date'] == null ? undefined : (new Date(json['coverage_end_date'])),
        'claim_last_date': json['claim_last_date'] == null ? undefined : (new Date(json['claim_last_date'])),
        'hsa_transfer_of_assets': json['hsa_transfer_of_assets'] == null ? undefined : json['hsa_transfer_of_assets'],
    };
}

export function IPlanTerminationPropertiesPatchDtoToJSON(json: any): IPlanTerminationPropertiesPatchDto {
    return IPlanTerminationPropertiesPatchDtoToJSONTyped(json, false);
}

export function IPlanTerminationPropertiesPatchDtoToJSONTyped(value?: IPlanTerminationPropertiesPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'coverage_end_date': value['coverage_end_date'] == null ? undefined : ((value['coverage_end_date']).toISOString()),
        'claim_last_date': value['claim_last_date'] == null ? undefined : ((value['claim_last_date']).toISOString()),
        'hsa_transfer_of_assets': value['hsa_transfer_of_assets'],
    };
}

